import { useTranslation } from 'react-i18next';

import { Iframe } from '~/modules/marketing/pages/catalog-anomaly-dashboard/components/iframe/IFrame';

export function ShortTermForecastingPage() {
  const { t } = useTranslation('marketing');

  return (
    <Iframe
      urlEnvKey="VITE_WMG_EMBED_MARKETING_SHORT_TERM_FORECASTING_DASHBOARD_URL"
      ariaLabel={t('anomalyDashboard.tabs.shortTermForecasting')}
    />
  );
}

ShortTermForecastingPage.displayName = 'ShortTermForecastingPage';
